import React from 'react';
import WarningCircle from '@elliemae/ds-icons/WarningCircle';
import CheckmarkCircle from '@elliemae/ds-icons/CheckmarkCircle';
import HelpCircle from '@elliemae/ds-icons/HelpCircle';
import InfoCircle from '@elliemae/ds-icons/InfoCircle';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import { MODAL_TYPE } from '../../constants.js';

var feedbackIconSize = 'xxl';
var WARNING = MODAL_TYPE.WARNING,
    ERROR = MODAL_TYPE.ERROR,
    SUCCESS = MODAL_TYPE.SUCCESS,
    HELP = MODAL_TYPE.HELP,
    INFO = MODAL_TYPE.INFO;

var getModalType = function getModalType(modalType, _ref) {
  var hasError = _ref.hasError,
      hasWarning = _ref.hasWarning,
      hasSuccess = _ref.hasSuccess,
      hasInfo = _ref.hasInfo,
      hasHelp = _ref.hasHelp;
  if ([WARNING, ERROR, SUCCESS, HELP, INFO].indexOf(modalType) > -1) return modalType;
  if (hasError) return ERROR;
  if (hasWarning) return WARNING;
  if (hasSuccess) return SUCCESS;
  if (hasHelp) return HELP;
  if (hasInfo) return INFO;
  return INFO;
};

var getIconType = function getIconType(modalType) {
  switch (modalType) {
    case WARNING:
    case ERROR:
      return /*#__PURE__*/React.createElement(WarningCircle, {
        size: feedbackIconSize
      });

    case SUCCESS:
      return /*#__PURE__*/React.createElement(CheckmarkCircle, {
        size: feedbackIconSize
      });

    case HELP:
      return /*#__PURE__*/React.createElement(HelpCircle, {
        size: feedbackIconSize
      });

    case INFO:
      return /*#__PURE__*/React.createElement(InfoCircle, {
        size: feedbackIconSize
      });

    default:
      return /*#__PURE__*/React.createElement(InfoCircle, {
        size: feedbackIconSize
      });
  }
};

var ModalFeedBack = function ModalFeedBack(_ref2) {
  var _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$modalType = _ref2.modalType,
      modalType = _ref2$modalType === void 0 ? null : _ref2$modalType,
      _ref2$hasError = _ref2.hasError,
      hasError = _ref2$hasError === void 0 ? false : _ref2$hasError,
      _ref2$hasWarning = _ref2.hasWarning,
      hasWarning = _ref2$hasWarning === void 0 ? false : _ref2$hasWarning,
      _ref2$hasSuccess = _ref2.hasSuccess,
      hasSuccess = _ref2$hasSuccess === void 0 ? false : _ref2$hasSuccess,
      _ref2$hasInfo = _ref2.hasInfo,
      hasInfo = _ref2$hasInfo === void 0 ? false : _ref2$hasInfo,
      _ref2$hasHelp = _ref2.hasHelp,
      hasHelp = _ref2$hasHelp === void 0 ? false : _ref2$hasHelp;
  var type = getModalType(modalType, {
    hasError: hasError,
    hasWarning: hasWarning,
    hasSuccess: hasSuccess,
    hasInfo: hasInfo,
    hasHelp: hasHelp
  });

  var _convertPropToCssClas = convertPropToCssClassName('modal-feedback', className, {
    modalType: type
  }),
      cssClassName = _convertPropToCssClas.cssClassName;

  var feedbackIcon = getIconType(type);
  return /*#__PURE__*/React.createElement("div", {
    className: cssClassName
  }, feedbackIcon);
};

export default ModalFeedBack;
//# sourceMappingURL=ModalFeedBack.js.map
